import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Table,
  Button,
  Input,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap"
import {
  FaPlus,
  FaEdit,
  FaEye,
  FaTrash,
  FaChevronRight,
  FaChevronLeft,
  FaFileImport,
  FaSave,
  FaFileExcel,
} from "react-icons/fa"
import VendorModal from "./VendorModal"
import Breadcrumb from "components/Common/Breadcrumb"
import { MdCancel, MdImportExport, MdUpload } from "react-icons/md"
import Loader from "components/Loader/loader"
import Swal from "sweetalert2"
import SheetModal from "./SheetModal"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import samplefile from "../../assets/vendor.xlsx"
import { Switch } from "antd"
import { RiCoupon3Line } from "react-icons/ri"
import { usePermissionData } from "AppContext"

const VendorIndex = () => {
  document.title = "Vendor | Milano Jewelry"

  const { checkAccess } = usePermissionData()

  const [vendors, setVendors] = useState([])
  const [search, setSearch] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState("add") // add, edit, view
  const [selectedVendor, setSelectedVendor] = useState({})

  const [importModal, setImportModal] = useState(false)
  const [importFile, setImportFile] = useState(null)
  const [importError, setImportError] = useState(false)

  const [loading, setLoading] = useState(false)

  const [sheetModal, setSheetModal] = useState(false)
  const [sheetData, setSheetData] = useState(null)

  /* ================= SAMPLE DATA ================= */
  useEffect(() => {
    fetchVendors()
  }, [])

  async function fetchVendors() {
    const APIdata = await fetchData(setLoading, "vendor")
    if (APIdata?.success) {
      setVendors(APIdata?.data)
    }
  }

  /* ================= SEARCH ================= */
  const filteredVendors = vendors.filter(vendor => {
    const term = search.toLowerCase()
    return (
      String(vendor.vendor_id ?? "").toLowerCase().includes(term) ||
      String(vendor.company ?? "").toLowerCase().includes(term) ||
      String(vendor.name ?? "").toLowerCase().includes(term) ||
      String(vendor.email ?? "").toLowerCase().includes(term) ||
      String(vendor.phone ?? "").toLowerCase().includes(term) ||
      String(vendor.city ?? "").toLowerCase().includes(term)
    )
  })

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredVendors.length / pageSize)
  const paginatedVendors = filteredVendors.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  )

  /* ================= MODAL HANDLERS ================= */
  const openModal = (mode, vendor = {}) => {
    setModalMode(mode)
    setSelectedVendor(vendor)
    setModalOpen(true)
  }

  const handleSubmit = async () => {
    if (selectedVendor?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "vendor",
        selectedVendor?.id,
        selectedVendor
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Vendor Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          fetchVendors()
        }, 1000)
      } else {
        Swal.fire({
          title: "Error Updating Vendor",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "vendor", selectedVendor)
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Vendor Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          fetchVendors()
        }, 1000)
      } else {
        Swal.fire({
          title: "Error Adding Vendor",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to Delete this ${item?.company} Vendor`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }
    const APIdata = await FetchDeleteData(setLoading, "vendor", item?.id)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Vendor Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        fetchVendors()
      }, 1000)
    } else {
      Swal.fire({
        title: "Error Deleting Vendor",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleFileImport = async () => {
    if (!importFile) {
      setImportError(true)
      return
    }
    const APIdata = await FetchPostData(setLoading, "vendor/import", {
      vendors: importFile,
    })
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Vendors imported Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setImportModal(false)
      fetchVendors()
    } else {
      Swal.fire({
        title: "Error Importing Vendors",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleStatusChange = async (id, status) => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to ${status ? "Active" : "InActive"} Vendor`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }
    const APIdata = await FetchPutData(setLoading, "vendor", id, { status })
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Vendor Status Changed Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        fetchVendors()
      }, 1000)
    } else {
      Swal.fire({
        title: "Error changing Vendor status",
        text: APIdata?.response?.data?.message,
        icon: "success",
      })
    }
  }

  const handleSheetClick = item => {
    setSelectedVendor(item)
    setSheetModal(true)
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Dashboard" breadcrumbItem="Vendor" />

      <Card>
        <CardBody>
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-2">
              <select
                className="form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                  setCurrentPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>

              <Input
                placeholder="Search..."
                value={search}
                onChange={e => {
                  setSearch(e.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>

            {checkAccess(3, "add") && (
              <div className="d-flex gap-3 align-items-center">
                <Button
                  className="bg-info"
                  onClick={() => setImportModal(true)}
                >
                  <FaFileImport className="me-1" />
                  Import
                </Button>
                <Button className="btn-blue" onClick={() => openModal("add")}>
                  <FaPlus className="me-1" />
                  Add Vendor
                </Button>
              </div>
            )}
          </div>

          <Table striped responsive>
            <thead className="table-blue">
              <tr>
                <th>#</th>
                <th>Vendor Company</th>
                <th>Vendor Id</th>

                <th>Contact Person</th>
                <th>Email</th>
                <th>Phone</th>
                <th>City</th>
                <th>Status</th>
                <th style={{ minWidth: "15%" }}>Actions</th>
                <th>Promotion</th>
              </tr>
            </thead>
            <tbody>
              {paginatedVendors.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Vendors Found
                  </td>
                </tr>
              )}

              {paginatedVendors.map((vendor, index) => (
                <tr key={vendor.id}>
                  <td>{(currentPage - 1) * pageSize + index + 1}</td>{" "}
                  <td>{vendor.company}</td>
                  <td>{vendor.vendor_id}</td>
                  <td>{vendor.name}</td>
                  <td>{vendor.email}</td>
                  <td>{vendor.phone}</td>
                  <td>{vendor.city}</td>
                  <td>

                    <Switch
                      checked={vendor?.status}
                      onChange={checked =>
                        handleStatusChange(vendor?.id, checked)
                      }
                      disabled={!checkAccess(3, "edit")}
                    />
                  </td>
                  <td>
                    <Button
                      color="secondary"
                      className="me-1"
                      onClick={() => openModal("view", vendor)}
                    >
                      <FaEye />
                    </Button>
                    {
                      checkAccess(3, "edit") && (
                        <Button
                          color="success"
                          className="me-1"
                          onClick={() => openModal("edit", vendor)}
                        >
                          <FaEdit />
                        </Button>
                      )
                    }
                    {
                      checkAccess(3, "delete") && (
                        <Button color="danger" onClick={() => handleDelete(vendor)}>
                          <FaTrash />
                        </Button>
                      )}
                  </td>
                  <td>
                    {
                      checkAccess(3, "edit") && (
                        <Button
                          color="blue"
                          onClick={() => handleSheetClick(vendor)}
                        >
                          <RiCoupon3Line />
                        </Button>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* ===== PAGINATION ===== */}
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {currentPage} of {totalPages || 1}
            </span>
            {/* ===== PAGINATION ===== */}
            <div className="d-flex justify-content-center align-items-center gap-2 ">
              {/* Previous */}
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => prev - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>

              {/* Page Numbers (Show 5 at a time) */}
              {(() => {
                const pageNumbers = []
                const maxVisiblePages = 5

                let startPage = Math.max(
                  1,
                  currentPage - Math.floor(maxVisiblePages / 2)
                )

                let endPage = startPage + maxVisiblePages - 1

                if (endPage > totalPages) {
                  endPage = totalPages
                  startPage = Math.max(1, endPage - maxVisiblePages + 1)
                }

                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(
                    <Button
                      key={i}
                      color={currentPage === i ? "primary" : "light"}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i}
                    </Button>
                  )
                }

                return pageNumbers
              })()}

              {/* Next */}
              <Button
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(prev => prev + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      <VendorModal
        open={modalOpen}
        close={() => setModalOpen(false)}
        formData={selectedVendor}
        setFormData={setSelectedVendor}
        onSubmit={handleSubmit}
        mode={modalMode}
      />

      <Modal isOpen={importModal}>
        <ModalHeader toggle={() => setImportModal(false)}>
          Import Vendor File
        </ModalHeader>
        <ModalBody>
          {/* Step 1: Download Sample */}
          <div className="bg-white p-3">
            <div className="mb-3">
              <span className="d-block mb-1">Step 1: Download Sample File</span>
              <a
                href={samplefile} // replace with your actual file path/API
                download
                className="btn btn-sm btn-outline-primary"
              >
                Download Sample Excel
              </a>
            </div>

            {/* Step 2: Instructions */}
            <div className="mb-3">
              <span className="d-block">
                Step 2: Update the file with your data (do not change column
                names)
              </span>
            </div>

            {/* Step 3: Upload */}
            <div className="mb-3">
              <Label>Step 3: Upload Updated File</Label>
              <Input
                type="file"
                className="form-control"
                accept=".xlsx, .xls, .csv"
                onChange={e => setImportFile(e.target.files?.[0])}
              />
              {importError && (
                <span className="text-danger">
                  Please select a file to import
                </span>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-blue" onClick={() => handleFileImport()}>
            <MdUpload /> Import
          </Button>
          <Button color="secondary" onClick={() => setImportModal(false)}>
            <MdCancel /> Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <SheetModal
        open={sheetModal}
        close={() => setSheetModal(false)}
        vendorData={selectedVendor}
      ></SheetModal>
    </div>
  )
}

export default VendorIndex
